const FILTERS_TARGET_ID = 'CollectionFilters';
const LEGACY_RESULTS_HASH = '#ResultsList';

/**
 * Sticky header offset for collection PLP anchor scroll.
 * @returns {number}
 */
export function getCollectionPlpScrollOffset() {
  const headerHeight = parseFloat(
    getComputedStyle(document.body).getPropertyValue('--header-group-height')
  );

  return Number.isNaN(headerHeight) ? 0 : headerHeight;
}

/**
 * Filters bar element to scroll to (mobile toggle row or desktop facets block).
 * @returns {HTMLElement | null}
 */
export function getCollectionFiltersElement() {
  const wrapper = document.querySelector('.collection-wrapper');
  if (!wrapper) return document.getElementById(FILTERS_TARGET_ID);

  const toggle = wrapper.querySelector('.facets-toggle');
  if (toggle instanceof HTMLElement && getComputedStyle(toggle).display !== 'none') {
    return toggle;
  }

  return document.getElementById(FILTERS_TARGET_ID);
}

/**
 * Scroll so the filters bar sits below the sticky header.
 * @param {ScrollBehavior} [behavior='instant']
 */
export function scrollToCollectionFilters(behavior = 'instant') {
  const filtersTarget = getCollectionFiltersElement();
  if (!filtersTarget) return;

  const top = filtersTarget.getBoundingClientRect().top + window.scrollY - getCollectionPlpScrollOffset();
  window.scrollTo({ top: Math.max(0, top), behavior });
}


function handleHashScroll() {
  const hash = window.location.hash;
  if (hash === `#${FILTERS_TARGET_ID}` || hash === LEGACY_RESULTS_HASH) {
    requestAnimationFrame(() => scrollToCollectionFilters('instant'));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleHashScroll, { once: true });
} else {
  handleHashScroll();
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const link = event.target.closest(`a[href="#${FILTERS_TARGET_ID}"], a[href="${LEGACY_RESULTS_HASH}"]`);
  if (!(link instanceof HTMLAnchorElement) || !getCollectionFiltersElement()) return;

  event.preventDefault();
  const behavior = link.classList.contains('collection-hero__skip') ? 'smooth' : 'instant';
  scrollToCollectionFilters(behavior);
});
